/**
 * Service Benefits Section
 * Handles theme editor support and dynamic content updates
 */

class ServiceBenefits extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    // Handle section reload in theme editor
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.detail.sectionId;
      if (this.closest('.shopify-section')?.id?.includes(section)) {
        this.updateDividers();
      }
    });

    // Handle block updates
    document.addEventListener('shopify:block:select', () => {
      this.updateDividers();
    });

    document.addEventListener('shopify:block:deselect', () => {
      this.updateDividers();
    });

    this.updateDividers();
  }

  updateDividers() {
    // Dividers are handled by CSS, but we can add logic here if needed
    const grid = this.querySelector('.service-benefits-grid');
    if (grid) {
      const items = grid.querySelectorAll('.service-benefit-item');
      items.forEach((item, index) => {
        if (index < items.length - 1) {
          item.classList.add('service-benefit-item--has-divider');
        } else {
          item.classList.remove('service-benefit-item--has-divider');
        }
      });
    }
  }
}

// Register the custom element
if (!customElements.get('service-benefits')) {
  customElements.define('service-benefits', ServiceBenefits);
}

// Initialize existing sections on page load
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.service-benefits-wrapper');
  sections.forEach((section) => {
    if (!section.querySelector('service-benefits')) {
      const benefits = document.createElement('service-benefits');
      section.appendChild(benefits);
    }
  });
});
